<script setup lang="ts">

</script>

<template>
  <div class="w-full">
    <div class="mx-auto flex flex-col items-center gap-y-6">
      <img
        class="size-[88px] object-cover"
        src="@/assets/images/emojis/emoji-hand.png"
      >
      <div class="flex flex-col gap-y-2 text-base font-medium text-white/60">
        <div class="text-center text-light-white text-[18px] leading-7 font-bold">
          What You Can Do Now
        </div>
        <ul class="list-disc pl-5">
          <li>
            <span class="text-white/[.87] font-semibold">🔥</span> Dive deeper into gameplay and <span
              class="text-white/[.87] font-semibold"
            >unlock more achievements</span>
          </li>
          <li>
            <span class="text-white/[.87] font-semibold">🏆</span> Take on quests, events, and daily challenges
          </li>
          <li>
            <span class="text-white/[.87] font-semibold">🚀</span> <span class="text-white/[.87] font-semibold">Engage on-chain</span>
            and unlock <span
              class="text-white/[.87] font-semibold"
            >special event</span> rewards
          </li>
          <li>
            <span class="text-white/[.87] font-semibold">🤝</span> <span class="text-white/[.87] font-semibold">Grow your streaks</span>
            and referrals
          </li>
        </ul>
        <p>
          May 31 is just the beginning—keep the momentum going for a legendary airdrop!
        </p>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>